import React, { useState, useEffect } from "react";
import SideBar from "../../admincomponent/Sidebar";
// import TopBar from "./topbar";
import Layout from "./layout";
function Domicile() {
  const [open, setOpen] = useState(false);

  // Function to update the 'open' state based on screen width
  const updateOpenState = () => {
    const screenWidth = window.innerWidth;
    if (screenWidth >= 768) {
      setOpen(true); // Open the sidebar for screens wider than or equal to 768px
    } else {
      setOpen(false); // Close the sidebar for smaller screens
    }
  };

  // Add a resize event listener to update 'open' state on window resize
  useEffect(() => {
    updateOpenState(); // Set initial 'open' state based on screen width
    window.addEventListener("resize", updateOpenState);
    return () => {
      window.removeEventListener("resize", updateOpenState);
    };
  }, []);

  return (
    <>
      <div className="flex bg-white">
        <div
          className={`transition-all ease-in-out z-10`}
          style={{ width: open ? "14%" : "3%" }}
        >
          <SideBar open={open} setOpen={setOpen} />
        </div>
        <div
          className={`ml-auto transition-all ease-in-out`}
          style={{ width: open ? "86%" : "97%" }}
        >
          <Layout setOpen={open} open={setOpen} />
        </div>
      </div>
    </>
  );
}

export default Domicile;
